var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1369_2468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.926758,
    y: 0.196411,
    width: 21.7267,
    height: 22.0757,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1369_2468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.70342 15.4737L11.3065 13.8277L13.9096 15.4954L13.2278 12.3765L15.521 10.2972L12.5047 10.0157L11.3065 7.07002L10.1083 9.994L7.09199 10.2756L9.38518 12.3765L8.70342 15.4737ZM11.3065 15.3554L8.09159 17.388C7.97188 17.4613 7.8519 17.4921 7.73166 17.4805C7.61141 17.4688 7.50255 17.4263 7.40508 17.353C7.30762 17.2797 7.23241 17.1839 7.17944 17.0656C7.12645 16.9473 7.11798 16.8166 7.15401 16.6733L8.00738 12.8463L5.16912 10.2706C5.06317 10.1739 4.99564 10.062 4.96651 9.93487C4.93738 9.80769 4.94506 9.68412 4.98954 9.56417C5.03404 9.44421 5.09814 9.34619 5.18184 9.27011C5.26554 9.19403 5.37996 9.14433 5.5251 9.12101L9.27079 8.7778L10.7249 5.16407C10.7778 5.02968 10.8581 4.93028 10.9656 4.86585C11.0732 4.80143 11.1868 4.76923 11.3065 4.76923C11.4262 4.76923 11.5398 4.80143 11.6474 4.86585C11.7549 4.93028 11.8352 5.02968 11.8881 5.16407L13.3422 8.7778L17.0879 9.12101C17.233 9.14433 17.3475 9.19403 17.4312 9.27011C17.5149 9.34619 17.579 9.44421 17.6235 9.56417C17.6679 9.68412 17.6756 9.80769 17.6465 9.93487C17.6174 10.062 17.5498 10.1739 17.4439 10.2706L14.6056 12.8463L15.459 16.6733C15.495 16.8166 15.4865 16.9473 15.4336 17.0656C15.3806 17.1839 15.3054 17.2797 15.2079 17.353C15.1104 17.4263 15.0016 17.4688 14.8813 17.4805C14.7611 17.4921 14.6411 17.4613 14.5214 17.388L11.3065 15.3554Z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/FavIcon.dcb4a18109efea84fac95b598adab05f.svg";
export { ForwardRef as ReactComponent };